import React from 'react';
import SearchBox from '../../../../../common/SearchBox';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

type GridHeaderProps = {
  classes: Record<string, string>;
  gridApi: unknown;
  updateQuickFilterText: (value: string) => void;
};

const GridHeader = ({ classes, gridApi, updateQuickFilterText }: GridHeaderProps) => (
  <div className={classes.gridHead}>
    <span className={classes.sectionTitle}>ALIASES</span>
    <div className={classes.searchContainer}>
      <SearchBox onChange={updateQuickFilterText} />
      <ClearAllFilterButton gridApi={gridApi} />
    </div>
  </div>
);

export default GridHeader;
